import axios from 'axios';
import {toast} from 'react-toastify';
import Cookies from 'js-cookie';
import {instance} from './api';

class HttpClient {

    constructor(callback, options = {}) {
        this.Callback = callback;
        this.Params = options.params || "";
        this.BaseURL = options.baseURL || "";
        this.Headers = options.headers || {};

    }

    // eslint-disable-next-line consistent-return
    async FetchJSON(endpoint, options = {},isBlob) {
        // eslint-disable-next-line no-unused-expressions
        this.Callback.beforeSend !== undefined && this.Callback.beforeSend()
        instance()
        try {
            return await axios({
                url: this.BaseURL + endpoint + this.Params,
                headers: this.Headers,
                method: options.method,
                data: options.body,
                responseType: isBlob ? "blob" : "json"
            })
        } catch (error) {
            if (error.response) {
                this.handleResponse(false, error)
            }
        }
    }

    setBearerAuth(token) {
        this.Headers.Authorization = `${token}`
        return this
    }


    setHeader(key, value) {
        this.Headers[key] = value;
        return this;
    }

    addHeader(newHeader) {
        this.Headers = {...this.Headers, ...newHeader};
        return this;
    }


    addParam(key, value) {
        const sign = this.Params ? "&" : "?";
        this.Params += `${sign + key}=${value}`;
        return this;

    }

    addParams(paramsObg, mapArray) {

        let sign = this.Params ? "&" : "?";
        Object.entries(paramsObg).forEach(([key, value]) => {
            sign = this.Params ? "&" : "?";

            try {
                if (isNaN(Number(value)) && Array.isArray(JSON?.parse(value)) && mapArray) {
                    /*  JSON?.parse(value)?.map((item) => {
                          this.Params += `${sign + key}=${item}`;
                          sign = '&'
                      })*/
                    JSON?.parse(value)?.forEach((item) => {
                        this.Params += `${sign + key}=${item}`;
                        sign = '&';
                    });

                } else {

                    this.Params += `${sign + key}=${value}`;
                }
            } catch (e) {
                this.Params += `${sign + key}=${value}`;

            }


        });
        return this;

    }

    appendParams(params) {
        this.Params = params;
        return this;

    }

    setBaseUrl(url) {
        this.BaseURL = url;
        return this;
    }

    setLocale(lang = 'fa') {
        this.Locale = lang;
        return this;
    }

    setUserAgent(req) {
        let real_ip = '';
        let forwarded_id = '';
        let ar_real_ip = '';
        if (req.headers["x-forwarded-for"]) {
            // eslint-disable-next-line prefer-destructuring
            forwarded_id = req.headers["x-forwarded-for"].split(',')[0]
        } else if (req.headers["x-real-ip"]) {
            real_ip = req.headers["x-real-ip"]
        } else if (req.headers["ar-real-ip"]) {
            ar_real_ip = req.headers["ar-real-ip"]
        } else {
            real_ip = req.connection.remoteAddress
        }
        this.setHeader('x-forwarded-for', forwarded_id)
        this.setHeader('x-real-ip', real_ip)
        this.setHeader('ar-real-ip', ar_real_ip)
        this.setHeader('user-agent', req.headers["user-agent"])
        return this;
    }

    rawHttpRequest(endpoint, options = {},isBlob) {
        return this.FetchJSON(endpoint, {
            parseResponse: false, ...options,
        },isBlob).then(data => {
            // eslint-disable-next-line no-unused-expressions
            data !== undefined && this.handleResponse(true, data.data)
        })
    }

    get(endpoint, options = {},isBlob) {

        options.method = "GET";
        return this.rawHttpRequest(endpoint, options,isBlob);
    }

    post(endpoint, body, options = {}) {

        options.method = "POST";
        options.body = JSON.stringify(body)

        return this.rawHttpRequest(endpoint, options);


    }

    upload(endpoint, body, options = {}) {

        const formData = new FormData()
        Object.entries(body).forEach(([key, value]) => formData.append(key, value));
        options.method = "POST";
        options.body = formData
        this.setHeader('Content-Type', 'multipart/form-data')
        return this.rawHttpRequest(endpoint, options);

    }

    update(endpoint, body, options = {}) {

        options.method = "PATCH";
        options.body = JSON.stringify(body)

        return this.rawHttpRequest(endpoint, options);
    }

    put(endpoint, body, options = {}) {

        options.method = "PUT";
        options.body = JSON.stringify(body)

        return this.rawHttpRequest(endpoint, options);
    }

    delete(endpoint, options = {}) {
        options.method = "DELETE";
        return this.rawHttpRequest(endpoint, options);
    }

    handleResponse(status, data) {
        if (status) {
            // eslint-disable-next-line no-unused-expressions
            this.Callback.success !== undefined && this.Callback.success(data)
        } else if (data?.message !== 'Network Error') {

            if (this?.Callback?.error !== undefined && data?.response?.status !== 400 && data?.response?.status !== 401 && data?.response?.status !== 403) {
                this.Callback.error(data)
            }

            if (data?.response?.status) {
                switch (data.response.status) {
                    case 404:
                        toast.error(data.response?.message);
                        break;

                    case 401:
                        Cookies.remove('token')
                        if (typeof window !== 'undefined') {
                            window.location.href = `/login`;
                        }
                        break;
                    case 422:
                        break;
                    case 400:
                        toast.error(data.response?.data);
                        break;
                    case 403:
                        toast.error('شما یه این بخش دسترسی ندارید.');
                        break;
                    case 500:
                        toast.error('خطای سرور ...');
                        break;
                    default:
                        break
                }
            }


        } else if (this.Callback.failed !== undefined) {
            this.Callback.failed(data)
        } else {
            toast.error('از اتصال خود به شبکه و خاموش بودن VPN خود اطمینان حاصل نمایید ');

        }

        // eslint-disable-next-line no-unused-expressions
        this.Callback.final !== undefined && this.Callback.final()

    }


}

export default HttpClient;

